import {WeightingService, GuideType} from 'domain/ports';
import { Ponderaciones } from '../../domain';
import axios, { AxiosInstance, AxiosError } from 'axios';
import {API_BASE_URL, API_ENDPOINTS} from 'constants/app';

export class HttpWeightingService implements WeightingService {
  private readonly http: AxiosInstance;

  constructor(baseUrl: string = API_BASE_URL) {
    this.http = axios.create({
      baseURL: baseUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async getWeightings(guideCode: GuideType): Promise<Ponderaciones> {
    try {
      const response = await this.http.get(
        API_ENDPOINTS.WEIGHTINGS(guideCode)
      );
      if (response.status === 200) {
        return this.mapToPonderaciones(response.data);
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        console.error('Error fetching weightings:', axiosError.message);
        throw new Error(`Error al obtener ponderaciones: ${axiosError.response?.status || 'Error de red'}`);
      }
      console.error('Unexpected error:', error);
      throw error;
    }
  }

  private mapToPonderaciones(data: any): Ponderaciones {
    return {
      finalWeighting: data.finalWeighting,
      categories: data.categories,
      domains: data.domains,
    };
  }
}
